/*
 * @Description: 本地化存储常量定义
 * @Author: 刘宝顺
 * @Date: 2024-02-01 14:14:38
 * @LastEditTime: 2024-08-22 14:33:15
 * @LastEditors: 刘宝顺
 */

/**
 * @description: 用于存储的key枚举
 * 命名规则推荐：
 *  1、key与value保持一致，可以防止storage重名
 *  2、key的命名增加对应功能类别的前缀，方便查找，比如：user，factory，setting；
 * @author: 刘宝顺
 * @return {*}
 */
enum EStorageConst {
    languageKey = 'languageKey',
    countryCodeAndRegion = 'countryCodeAndRegion', // 根据ip获取用户所在地区配置的数据，存在sessionStorage中，当前用于确定观测云数据上报服务器站点
}

export default EStorageConst;
